module.exports = __webpack_public_path__ + "static/img/10012 (4).d4df983.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10012 (4).webp
// module id = 3ZoG
// module chunks = 14